'use client';

import { AnchorHTMLAttributes, ReactNode } from 'react';
import { Link, LinkProps } from 'react-scroll';

type ScrollButtonProps = LinkProps &
    AnchorHTMLAttributes<HTMLAnchorElement> & {
        children: ReactNode;
        smooth: boolean;
        className?: string | undefined;
    };

export default function ScrollButton({ to, children, className, smooth }: ScrollButtonProps) {
    return (
        <Link to={to} className={className} smooth={smooth}>
            {children}
        </Link>
    );
}
